import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { ChangePasswordForm } from '../ChangePasswordForm/ChangePasswordForm';

export const ChangePasswordPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        Change Password
      </h1>
      <ChangePasswordForm />
    </Layout>
  );
};
